import React, { useState } from 'react'
import ReactModal from 'react-modal';
import ChangeOccupants from '../ChangeOccupants'
import { Tooltip as ReactTooltip } from 'react-tooltip';
import ReactDOMServer from 'react-dom/server';
import RoomPriceText from '../RoomPriceText.js'

export default function SummaryRoom(props) {

    const [showModal, setShowModal] = useState(false);
    const [showPolicy, setShowPolicy] = useState(false);

    const modalStyle = () => ({
        overlay: {
            display: 'inline-block',
            position: 'fixed',
            overflow: 'hidden',
            //height: '100%'
            //top: 0,
            //left: 0,
            //right: 0,
            //bottom: 0,
            //backgroundColor: 'rgba(255, 255, 255, 0.75)'
        },
        content: {
            display: 'block',
            verticalAlign: 'middle',
            //position: window.innerwidth > 600 ? 'relative' : 'fixed',
            top: window.innerWidth > 300 ? '128px' : '10px',
            //bottom: window.innerWidth > 300 ? '128px' : '10px',
            //left: window.innerWidth > 600 ? 'none' : '0px',
            //right: window.innerWidth > 600 ? 'none' : '0px',
            width: window.innerWidth > 300 ? '340px' : '340px',
            height: '243px',
            //border: '1px solid #ccc',
            background: '#fff',
            overflow: isTouchDevice() ? 'auto' : 'auto',
            WebkitOverflowScrolling: 'touch',
            //borderRadius: '4px',
            outline: 'none',
            padding: '6px',
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    })

    function isTouchDevice() {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    }

    function closeChangeOccupants(adults, children) {
        setShowModal(false);
    }

    function close() {
        setShowModal(false);
    }

    function pluralise(string, qty) {
        return qty + ' ' + string + (qty === 1 ? '' : 's');
    }

    function children(qty) {
        return qty === 0 ? '' : (qty === 1 ? ' 1 child' : (' ' + qty + ' children'));
    }

    return (

        <div>
            <ReactTooltip />
            <div className='row'>
                <div className='col-7'>
                    <div className='image-container' >
                        <img src={props.selectedRoom.roomType.mainImageUrl} alt={props.selectedRoom.roomType.name} className='room-image-thumb' />

                    </div>
                </div>
                <div className='col-5 text-right'><small><a href="" onClick={(e) => { e.preventDefault(); props.removeRoom(props.selectedRoom.roomType.name)  }} >remove this room</a></small>
                    
                </div>
            </div>
            <div className='row'>
                <div className='col-6'>
                    <small>{props.selectedRoom.roomType.name}<br />
                        <a href="" onClick={(e) => { e.preventDefault(); props.changeRoom(props.selectedRoom.roomType.name) }} >change room</a></small>
                </div>
                <div className='col-6 text-right'>
                    <div>
                        <small>£{(+props.selectedRoom.roomPrice.promoCodePrice).toFixed(2)}</small>

                    </div>
                    <div class="small text-danger text-right">
                        {props.selectedRoom.roomPrice.promoCode === "" ? "" : "Promo: " + props.selectedRoom.roomPrice.promoCode + " applied"}
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-6'>
                    <small>{pluralise('adult', props.selectedRoom.adults) + children(props.selectedRoom.children)}<br />
                        <a href="" onClick={(e) => { e.preventDefault(); setShowModal(true) }} >change occupants</a></small>

                </div>
                <div className='col-6 text-right'><small>
                    <div data-html={true} data-tip={ReactDOMServer.renderToString(<RoomPriceText roomPrice={props.selectedRoom.roomPrice} />)}>
                        <u>{props.selectedRoom.roomPrice.ratePlanName}</u></div>
                    <div>
                        {props.selectedRoom.roomPrice.mealPlan?.name}</div> </small>
                    { props.showViewTermsLink && !showPolicy &&
                        <small><a href="" onClick={(e) => { e.preventDefault(); setShowPolicy(true) }} >view terms</a></small>}
                    {props.showViewTermsLink && showPolicy &&
                        <small><a href="" onClick={(e) => { e.preventDefault(); setShowPolicy(false) }} >hide terms</a></small>}
                </div>
                {
                    showPolicy && <small><RoomPriceText roomPrice={props.selectedRoom.roomPrice} /></small>
                }
                <ReactModal
                    isOpen={showModal}
                    contentLabel="Minimal Modal Example"
                    style={modalStyle()}
                >

                    <ChangeOccupants
                        roomTypeName={props.selectedRoom.roomType.name}
                        roomType={props.selectedRoom.roomType}
                        adults={props.selectedRoom.adults}
                        changeAdults={props.changeAdults}
                        children={props.selectedRoom.children}
                        changeChildren={props.changeChildren}
                        apply={(adults, children) => closeChangeOccupants(adults, children)}
                        close={() => close()}
                    />

                </ReactModal>
            </div>
            
            <hr />
        </div>




    );


}